<script setup lang="ts">
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { addYears } from 'date-fns'
import Tools from '@/utils/tools'

const { t } = useI18n()

const cookie = Tools.getCookie('cookie-consent')
const consent = ref<boolean>(false)

if (cookie === 'accept_all_cookies' || cookie === 'accept_essential_cookies') {
	consent.value = true
	Tools.toggleScrollbar(true)
}
else {
	Tools.toggleScrollbar(false)
}

function accept(all: boolean) {
	const type = all ? 'accept_all_cookies' : 'accept_essential_cookies'

	Tools.setCookie('cookie-consent', type, addYears(new Date(), 1), `.${import.meta.env.VITE_DOMAIN}`, '/')
	consent.value = true
	Tools.toggleScrollbar(true)
}
</script>

<template>
	<div
		v-if="!consent"
		class="flex flex-col gap-2 fixed bottom-0 left-0 w-full z-[10000] bg-slate-900 p-4 shadow-lg shadow-black/50"
	>
		<h2 class="m-0 p-0 text-lg md:text-xl font-extrabold ">
			{{ t('legal.cookie_banner.title') }}
		</h2>
		<div class="text-sm md:text-base">
			{{ t('legal.cookie_banner.message') }}
		</div>

		<div class="flex w-full justify-center md:justify-end">
			<div class="flex gap-2">
				<Button
					:label="t('legal.cookie_banner.accept_essential')"
					class="button-orange-shade"
					outlined
					@click="accept(false)"
				/>
				<Button
					:label="t('legal.cookie_banner.accept_all')"
					class="button-orange-shade"
					@click="accept(true)"
				/>
			</div>
		</div>
		<!-- <div class="flex w-full justify-center items-center md:justify-between flex-col-reverse md:flex-row gap-4 md:gap-0">
			 <div class="flex gap-2 w-full md:w-fit flex-col md:flex-row">
				<a :href="`/legal/TOS.${useSettingStore().getLocale().code === 'fr' ? 'fr' : 'en'}.pdf`" class="!text-xs hyperlink-purple text-center" target="_blank"> {{ t('legal.tos') }}</a>
				<a :href="`/legal/PrivacyPolicy.${useSettingStore().getLocale().code === 'fr' ? 'fr' : 'en'}.pdf`" class="!text-xs hyperlink-purple text-center" target="_blank"> {{ t('legal.privacy_policy') }}</a>
			</div> -->
	</div>
</template>

<style scoped lang="scss">

</style>
